// import { React, useState, useEffect, useRef } from "react";
// import { useLocation, NavLink } from "react-router-dom";
// import PropTypes from "prop-types";
// import List from "@mui/material/List";
// import Divider from "@mui/material/Divider";
// import Link from "@mui/material/Link";
// import Icon from "@mui/material/Icon";
// import MDBox from "components/MDBox";
// import MDTypography from "components/MDTypography";
// import SidenavCollapse from "examples/Sidenav/SidenavCollapse";
// import SidenavRoot from "examples/Sidenav/SidenavRoot";
// import sidenavLogoLabel from "examples/Sidenav/styles/sidenav";
// import {
//   useMaterialUIController,
//   setMiniSidenav,
//   setTransparentSidenav,
//   setWhiteSidenav,
// } from "context";

// function Sidenav({ color, brand, brandName, routes, ...rest }) {
//   const [controller, dispatch] = useMaterialUIController();
//   const {
//     miniSidenav,
//     transparentSidenav,
//     whiteSidenav,
//     darkMode,
//     sidenavColor,
//   } = controller;
//   const location = useLocation();
//   const sidenavRef = useRef(null);
//   // Initialize openCollapse based on current route
//   const [openCollapse, setOpenCollapse] = useState(() => {
//     const initialOpenCollapse = {};
//     routes.forEach((route) => {
//       if (route.collapse) {
//         const isSubmenuActive = route.collapse.some(
//           (subRoute) => subRoute.route === location.pathname
//         );
//         if (isSubmenuActive) {
//           initialOpenCollapse[route.key] = true;
//         }
//       }
//     });
//     return initialOpenCollapse;
//   });

//   let textColor = "white";
//   if (transparentSidenav || (whiteSidenav && !darkMode)) {
//     textColor = "dark";
//   } else if (whiteSidenav && darkMode) {
//     textColor = "inherit";
//   }

//   const closeSidenav = () => setMiniSidenav(dispatch, true);

//   useEffect(() => {
//     function handleMiniSidenav() {
//       setMiniSidenav(dispatch, window.innerWidth < 1200);
//       setTransparentSidenav(
//         dispatch,
//         window.innerWidth < 1200 ? false : transparentSidenav
//       );
//       setWhiteSidenav(
//         dispatch,
//         window.innerWidth < 1200 ? false : whiteSidenav
//       );
//     }
//     window.addEventListener("resize", handleMiniSidenav);
//     handleMiniSidenav();
//     return () => window.removeEventListener("resize", handleMiniSidenav);
//   }, [dispatch, location]);

//   useEffect(() => {
//     function handleClickOutside(event) {
//       if (
//         sidenavRef.current &&
//         !sidenavRef.current.contains(event.target) &&
//         !miniSidenav // 👉 sirf jab open ho tab
//       ) {
//         setMiniSidenav(dispatch, true);
//       }
//     }

//     document.addEventListener("mousedown", handleClickOutside);

//     return () => {
//       document.removeEventListener("mousedown", handleClickOutside);
//     };
//   }, [miniSidenav, dispatch]);

//   const handleCollapseToggle = (key) => {
//     setOpenCollapse((prev) => ({
//       ...prev,
//       [key]: !prev[key],
//     }));
//   };

//   const renderRoutes = (routeItems, level = 0, parentKey = null) => {
//     return routeItems
//       .filter(({ visible }) => visible !== false)
//       .map(({ type, name, icon, title, noCollapse, key, href, route, collapse }) => {
//         let returnValue;

//         if (type === "collapse") {
//           const isOpen = openCollapse[key] || false;
//           const isActive = route === location.pathname || // Matches top-level route
//             (collapse && collapse.some((subRoute) => subRoute.route === location.pathname)); // Matches submenu route
//           const collapseContent = collapse && isOpen ? (
//             <List component="div" disablePadding sx={{ pl: level + 1 }}>
//               {renderRoutes(collapse, level + 1, key)}
//             </List>
//           ) : null;

//           returnValue = href ? (
//             <Link
//               href={href}
//               key={key}
//               target="_blank"
//               rel="noreferrer"
//               sx={{ textDecoration: "none" }}
//               onClick={() => handleCollapseToggle(key)}
//             >
//               <SidenavCollapse
//                 icon={icon}
//                 name={name}
//                 active={isActive}
//                 noCollapse={noCollapse}
//                 open={isOpen}
//                 hasCollapse={!!collapse}
//               >
//                 {collapseContent}
//               </SidenavCollapse>
//             </Link>
//           ) : (
//             <MDBox
//               key={key}
//               sx={{ textDecoration: "none" }}
//             >
//               {collapse ? (
//                 // Parent menu with submenu: only toggle, no navigation
//                 <SidenavCollapse
//                   icon={icon}
//                   name={name}
//                   active={isActive}
//                   open={isOpen}
//                   hasCollapse={!!collapse}
//                   onClick={() => handleCollapseToggle(key)}
//                 >
//                   {collapseContent}
//                 </SidenavCollapse>
//               ) : (
//                 // Leaf menu item: navigable
//                 <NavLink
//                   to={route}
//                   style={{ textDecoration: "none" }}
//                   onClick={(e) => {
//                     // Prevent parent submenu from closing if this is a submenu item
//                     if (parentKey && openCollapse[parentKey]) {
//                       e.stopPropagation();
//                     }
//                   }}
//                 >
//                   <SidenavCollapse
//                     icon={icon}
//                     name={name}
//                     active={route === location.pathname}
//                     open={isOpen}
//                     hasCollapse={!!collapse}
//                   >
//                     {collapseContent}
//                   </SidenavCollapse>
//                 </NavLink>
//               )}
//             </MDBox>
//           );
//         } else if (type === "title") {
//           returnValue

//             = (
//               <MDTypography
//                 key={key}
//                 color={textColor}
//                 display="block"
//                 variant="caption"
//                 fontWeight="bold"
//                 textTransform="uppercase"
//                 pl={3 + level * 2}
//                 mt={2}
//                 mb={1}
//                 ml={1}
//               >
//                 {title}
//               </MDTypography>
//             );
//         } else if (type === "divider") {
//           returnValue = (
//             <Divider
//               key={key}
//               light={
//                 (!darkMode && !whiteSidenav && !transparentSidenav) ||
//                 (darkMode && !transparentSidenav && whiteSidenav)
//               }
//             />
//           );
//         }

//         return returnValue;
//       });
//   };

//   const hoverTimeoutRef = useRef(null);

//   useEffect(() => {
//     function handleMiniSidenav() {
//       setMiniSidenav(dispatch, window.innerWidth < 1250);
//       setTransparentSidenav(
//         dispatch,
//         window.innerWidth < 1200 ? false : transparentSidenav
//       );
//       setWhiteSidenav(
//         dispatch,
//         window.innerWidth < 1200 ? false : whiteSidenav
//       );
//     }
//     window.addEventListener("resize", handleMiniSidenav);
//     handleMiniSidenav();
//     return () => {
//       window.removeEventListener("resize", handleMiniSidenav);
//       clearTimeout(hoverTimeoutRef.current);
//     };
//   }, [dispatch, transparentSidenav, whiteSidenav]);

//   const handleMouseEnter = () => {
//     if (window.innerWidth >= 1200) {
//       clearTimeout(hoverTimeoutRef.current);
//       hoverTimeoutRef.current = setTimeout(() => {
//         setMiniSidenav(dispatch, false);
//       }, 200);
//     }
//   };

//   const handleMouseLeave = () => {
//     if (window.innerWidth >= 1200) {
//       clearTimeout(hoverTimeoutRef.current);
//       hoverTimeoutRef.current = setTimeout(() => {
//         setMiniSidenav(dispatch, true);
//       }, 200);
//     }
//   };

//   return (
//     <SidenavRoot
//       ref={sidenavRef}
//       {...rest}
//       variant="permanent"
//       ownerState={{ transparentSidenav, whiteSidenav, miniSidenav, darkMode }}
//       onMouseEnter={handleMouseEnter}
//       onMouseLeave={handleMouseLeave}
//     >
//       <MDBox pt={3} pb={1} px={4} textAlign="center">
//         <MDBox
//           display={{ xs: "block", xl: "none" }}
//           position="absolute"
//           top={0}
//           right={0}
//           p={1.625}
//           onClick={closeSidenav}
//           sx={{ cursor: "pointer" }}
//         >
//           <MDTypography variant="h6" color="secondary">
//             <Icon sx={{ fontWeight: "bold" }}>close</Icon>
//           </MDTypography>
//         </MDBox>
//         <MDBox component={NavLink} to="/" display="flex" alignItems="center">
//           {brand && (
//             <MDBox component="img" src={brand} alt="Brand" width="2rem" />
//           )}
//           <MDBox
//             width={!brandName && "100%"}
//             sx={(theme) => sidenavLogoLabel(theme, { miniSidenav })}
//           >
//             <MDTypography
//               component="h6"
//               variant="button"
//               fontWeight="medium"
//               color={textColor}
//             >
//               {brandName}
//             </MDTypography>
//           </MDBox>
//         </MDBox>
//       </MDBox>
//       <Divider
//         light={
//           (!darkMode && !whiteSidenav && !transparentSidenav) ||
//           (darkMode && !transparentSidenav && whiteSidenav)
//         }
//       />
//       <List>{renderRoutes(routes)}</List>
//     </SidenavRoot>
//   );
// }

// Sidenav.defaultProps = {
//   color: "info",
//   brand: "",
// };

// Sidenav.propTypes = {
//   color: PropTypes.oneOf([
//     "primary",
//     "secondary",
//     "info",
//     "success",
//     "warning",
//     "error",
//     "dark",
//   ]),
//   brand: PropTypes.string,
//   brandName: PropTypes.string.isRequired,
//   routes: PropTypes.arrayOf(PropTypes.object).isRequired,
// };

// export default Sidenav;


import { React, useState, useEffect, useRef } from "react";
import { useLocation, NavLink } from "react-router-dom";
import PropTypes from "prop-types";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import Link from "@mui/material/Link";
import Icon from "@mui/material/Icon";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import SidenavCollapse from "examples/Sidenav/SidenavCollapse";
import SidenavRoot from "examples/Sidenav/SidenavRoot";
import sidenavLogoLabel from "examples/Sidenav/styles/sidenav";
import {
  useMaterialUIController,
  setMiniSidenav,
  setTransparentSidenav,
  setWhiteSidenav,
} from "context";

function Sidenav({ color, brand, brandName, routes, ...rest }) {
  const [controller, dispatch] = useMaterialUIController();
  const {
    miniSidenav,
    transparentSidenav,
    whiteSidenav,
    darkMode,
    sidenavColor,
  } = controller;

  const location = useLocation();
  const sidenavRef = useRef(null);
  const hoverTimeoutRef = useRef(null); // Hook declared at the top

  // 1. Define the specific paths where you want the Sidenav hidden
  const noSidenavPaths = ["/authentication/sign-in"];
  const isNoSidenavPath = noSidenavPaths.includes(location.pathname);

  // 2. Initialize openCollapse (Hook order must be preserved)
  const [openCollapse, setOpenCollapse] = useState(() => {
    const initialOpenCollapse = {};
    routes.forEach((route) => {
      if (route.collapse) {
        const isSubmenuActive = route.collapse.some(
          (subRoute) => subRoute.route === location.pathname
        );
        if (isSubmenuActive) {
          initialOpenCollapse[route.key] = true;
        }
      }
    });
    return initialOpenCollapse;
  });

  let textColor = "white";
  if (transparentSidenav || (whiteSidenav && !darkMode)) {
    textColor = "dark";
  } else if (whiteSidenav && darkMode) {
    textColor = "inherit";
  }

  const closeSidenav = () => setMiniSidenav(dispatch, true);

  // 3. Effect for Resize (Hook order preserved)
  useEffect(() => {
    if (isNoSidenavPath) return; // Exit logic early, but run the hook

    function handleMiniSidenav() {
      setMiniSidenav(dispatch, true);

      setTransparentSidenav(
        dispatch,
        window.innerWidth < 1200 ? false : transparentSidenav
      );

      setWhiteSidenav(
        dispatch,
        window.innerWidth < 1200 ? false : whiteSidenav
      );
    }

    window.addEventListener("resize", handleMiniSidenav);
    handleMiniSidenav();
    return () => window.removeEventListener("resize", handleMiniSidenav);
  }, [dispatch, location, isNoSidenavPath]);

  // 4. Effect for Outside Clicks (Hook order preserved)
  useEffect(() => {
    if (isNoSidenavPath) return;

    function handleClickOutside(event) {
      if (
        sidenavRef.current &&
        !sidenavRef.current.contains(event.target) &&
        !miniSidenav
      ) {
        setMiniSidenav(dispatch, true);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [miniSidenav, dispatch, isNoSidenavPath]);

  const handleCollapseToggle = (key) => {
    setOpenCollapse((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  const handleMouseEnter = () => {
    if (window.innerWidth >= 1200 && !isNoSidenavPath) {
      clearTimeout(hoverTimeoutRef.current);
      hoverTimeoutRef.current = setTimeout(() => {
        setMiniSidenav(dispatch, false);
      }, 200);
    }
  };

  const handleMouseLeave = () => {
    if (window.innerWidth >= 1200 && !isNoSidenavPath) {
      clearTimeout(hoverTimeoutRef.current);
      hoverTimeoutRef.current = setTimeout(() => {
        setMiniSidenav(dispatch, true);
      }, 200);
    }
  };

  const renderRoutes = (routeItems, level = 0, parentKey = null) => {
    return routeItems
      .filter(({ visible }) => visible !== false)
      .map(({ type, name, icon, title, noCollapse, key, href, route, collapse }) => {
        let returnValue;

        if (type === "collapse") {
          const isOpen = openCollapse[key] || false;
          const isActive = route === location.pathname ||
            (collapse && collapse.some((subRoute) => subRoute.route === location.pathname));

          const collapseContent = collapse && isOpen ? (
            <List component="div" disablePadding sx={{ pl: level + 1 }}>
              {renderRoutes(collapse, level + 1, key)}
            </List>
          ) : null;

          returnValue = href ? (
            <Link
              href={href}
              key={key}
              target="_blank"
              rel="noreferrer"
              sx={{ textDecoration: "none" }}
              onClick={() => handleCollapseToggle(key)}
            >
              <SidenavCollapse
                icon={icon}
                name={name}
                active={isActive}
                noCollapse={noCollapse}
                open={isOpen}
                hasCollapse={!!collapse}
              >
                {collapseContent}
              </SidenavCollapse>
            </Link>
          ) : (
            <MDBox key={key} sx={{ textDecoration: "none" }}>
              {collapse ? (
                <SidenavCollapse
                  icon={icon}
                  name={name}
                  active={isActive}
                  open={isOpen}
                  hasCollapse={!!collapse}
                  onClick={() => handleCollapseToggle(key)}
                >
                  {collapseContent}
                </SidenavCollapse>
              ) : (
                <NavLink
                  to={route}
                  style={{ textDecoration: "none" }}
                  onClick={(e) => {
                    if (parentKey && openCollapse[parentKey]) {
                      e.stopPropagation();
                    }
                  }}
                >
                  <SidenavCollapse
                    icon={icon}
                    name={name}
                    active={route === location.pathname}
                    open={isOpen}
                    hasCollapse={!!collapse}
                  >
                    {collapseContent}
                  </SidenavCollapse>
                </NavLink>
              )}
            </MDBox>
          );
        } else if (type === "title") {
          returnValue = (
            <MDTypography
              key={key}
              color={textColor}
              display="block"
              variant="caption"
              fontWeight="bold"
              textTransform="uppercase"
              pl={3 + level * 2}
              mt={2}
              mb={1}
              ml={1}
            >
              {title}
            </MDTypography>
          );
        } else if (type === "divider") {
          returnValue = (
            <Divider
              key={key}
              light={
                (!darkMode && !whiteSidenav && !transparentSidenav) ||
                (darkMode && !transparentSidenav && whiteSidenav)
              }
            />
          );
        }
        return returnValue;
      });
  };

  // ─────────────────────────────────────────────────────────────────
  // CRITICAL FIX: Conditionally return null AFTER all hooks have run
  // ─────────────────────────────────────────────────────────────────
  if (isNoSidenavPath) {
    return null;
  }

  return (
    <SidenavRoot
      ref={sidenavRef}
      {...rest}
      variant="permanent"
      ownerState={{ transparentSidenav, whiteSidenav, miniSidenav, darkMode }}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <MDBox pt={3} pb={1} px={4} textAlign="center">
        <MDBox
          display={{ xs: "block", xl: "none" }}
          position="absolute"
          top={0}
          right={0}
          p={1.625}
          onClick={closeSidenav}
          sx={{ cursor: "pointer" }}
        >
          <MDTypography variant="h6" color="secondary">
            <Icon sx={{ fontWeight: "bold" }}>close</Icon>
          </MDTypography>
        </MDBox>
        <MDBox
          component={NavLink}
          to="/"
          display="flex"
          alignItems="center"
          justifyContent="flex-start"
          sx={{ marginLeft: -1 }}
        >
          {brand && (
            <MDBox component="img" src={brand} alt="Brand" width="3rem" />
          )}
          <MDBox
            width={!brandName && "100%"}
            sx={(theme) => sidenavLogoLabel(theme, { miniSidenav })}
          >
            <MDTypography component="h6" variant="button" fontWeight="medium" color={textColor}>
              {brandName}
            </MDTypography>
          </MDBox>
        </MDBox>
      </MDBox>
      <Divider
        light={
          (!darkMode && !whiteSidenav && !transparentSidenav) ||
          (darkMode && !transparentSidenav && whiteSidenav)
        }
      />
      <List>{renderRoutes(routes)}</List>
    </SidenavRoot>
  );
}

Sidenav.defaultProps = {
  color: "info",
  brand: "",
};

Sidenav.propTypes = {
  color: PropTypes.oneOf([
    "primary",
    "secondary",
    "info",
    "success",
    "warning",
    "error",
    "dark",
  ]),
  brand: PropTypes.string,
  brandName: PropTypes.string.isRequired,
  routes: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default Sidenav;